import { render, staticRenderFns } from "./AgentFunction.vue?vue&type=template&id=46b7728e&scoped=true"
import script from "./AgentFunction.vue?vue&type=script&lang=js"
export * from "./AgentFunction.vue?vue&type=script&lang=js"
import style0 from "./AgentFunction.vue?vue&type=style&index=0&id=46b7728e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7728e",
  null
  
)

export default component.exports